import {
  JwtAuthenticationStore,
  SOFTLINE_FEATURE_JWT_AUTHENTICATION,
} from '@softline/auth';
import {
  CancelledError,
  ConnectionError,
  ForbiddenError,
  NetworkError,
  NotFoundError,
  RequestError,
  ServerError,
  Store,
  UnauthorizedError,
  UnknownResponseError,
  interpolate,
} from '@softline/core';
import {
  MessageBarStore,
  SOFTLINE_FEATURE_MESSAGE_BAR,
  SOFTLINE_FEATURE_TRANSLATION,
  TranslationStore,
} from '@softline/ui-core';

export function showRequestErrors(store: Store, error: unknown): void {
  const t = (key: string, obj?: object) => {
    const translation = store.get(
      SOFTLINE_FEATURE_TRANSLATION,
      TranslationStore.getters.translation,
      key
    );
    if (!obj) return translation;
    return interpolate(translation, obj);
  };

  if (error instanceof NetworkError)
    store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, {
      title: t('#APPLICATION.MESSAGES.ERRORS.NETWORK_TITLE', error),
      message: t('#APPLICATION.MESSAGES.ERRORS.NETWORK', error),
    });
  else if (error instanceof ConnectionError)
    store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, {
      title: t('#APPLICATION.MESSAGES.ERRORS.CONNECTION_TITLE', error),
      message: t('#APPLICATION.MESSAGES.ERRORS.CONNECTION', error),
    });
  else if (error instanceof RequestError)
    store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, {
      title: t('#APPLICATION.MESSAGES.ERRORS.REQUEST_TITLE', error),
      message: t('#APPLICATION.MESSAGES.ERRORS.REQUEST', error),
    });
  else if (error instanceof UnauthorizedError) {
    store.dispatch(
      SOFTLINE_FEATURE_MESSAGE_BAR,
      MessageBarStore.actions.error,
      t('#APPLICATION.MESSAGES.ERRORS.UNAUTHORIZED')
    );
    store.dispatch(
      SOFTLINE_FEATURE_JWT_AUTHENTICATION,
      JwtAuthenticationStore.actions.logout,
      { expired: true }
    );
  } else if (error instanceof ForbiddenError)
    store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, {
      message: t('#APPLICATION.MESSAGES.ERRORS.FORBIDDEN', error),
    });
  else if (error instanceof NotFoundError)
    store.dispatch(
      SOFTLINE_FEATURE_MESSAGE_BAR,
      MessageBarStore.actions.error,
      t('#APPLICATION.MESSAGES.ERRORS.NOT_FOUND')
    );
  else if (error instanceof ServerError)
    store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, {
      title: t('#APPLICATION.MESSAGES.ERRORS.SERVER_TITLE', error),
      message: t('#APPLICATION.MESSAGES.ERRORS.SERVER', error),
    });
  else if (error instanceof UnknownResponseError)
    store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, {
      title: t('#APPLICATION.MESSAGES.ERRORS.UNKNOWN_RESPONSE_TITLE', error),
      message: t('#APPLICATION.MESSAGES.ERRORS.UNKNOWN_RESPONSE', error),
    });
  else if (error instanceof CancelledError)
    store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.warning, {
      message: t('#APPLICATION.MESSAGES.ERRORS.CANCELLED', error),
    });
  else {
    store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, {
      title: t('#APPLICATION.MESSAGES.ERRORS.UNKNOWN_TITLE', error as Error),
      message: t('#APPLICATION.MESSAGES.ERRORS.UNKNOWN', error as Error),
    });
    throw error;
  }
}
